import { createMuiTheme } from "@material-ui/core";


const hoopstirTheme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  overrides: {
    Mui:{
      "root": {
        "&$disabled": {
          "&:before": {
            "borderBottom": "transparent",
            "borderBottomStyle": "none"
          },
          "borderBottomStyle": "none"
        }
      }
    },
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: '#5563b8', // 'rgba(64, 81, 180, .7)',
      },
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        // backgroundColor: lightBlue.A200,
        // color: "white",
      },
    },
    MuiPickersDay: {
      day: {
        color: '#162173',
      },
      // isSelected: {
      //   backgroundColor: lightBlue["400"],
      // },
      current: {
        color: '#4355ba',
      },
    },
    MuiInputLabel: {
      color: 'white'
    },
    MuiFormLabel: {
      input: {
        color: 'white'
      },
      root: {
        color: 'white'
      }
    },
    MuiInputBase: {
      root:{
        borderBottomStyle: 'none',
      },
      input: {
        fontFamily: 'Montserrat-Regular',
        color: 'black',
        borderBottomStyle: 'none',
      },
      adornedEnd: {
        color: 'white',
        background: 'red',
        border: '1px solid #ccc',
        fontSize: '14px',
        lineHeight: '1.42857143',
        borderRadius: '4px',
        padding: '6px 12px',
        height: '34px', // - this is what form control assigns to the fields. otherwise, '2.45em'
        fontFamily: 'Montserrat-Regular',
      }
    },
    MuiInput: {
      underline: {
        borderBottomStyle: 'none',
        '&:before': {
          borderBottom: 'none',
          borderBottomStyle: 'none',
        },
        '&&&&:hover:before': {
          borderBottom: 'none',
        },
        '&:after': {
          borderBottom: 'none',
        }
      }
    },
    MuiIconButton: {
      root: {
        color: 'rgba(255, 255, 255, 0.8)',
      }
    }, 
    MuiFormHelperText: {
      root: {
        // color: rgba(0, 0, 0, 0.54);
        fontSize: '1rem',
        marginTop: '4px',
        fontFamily: 'Montserrat-Regular',
        lineHeight: '1em',
        letterSpacing: 'none',
        "&$error": {
          // display: 'none',
          color: "#fc6723"
        }
      }
    },
  }
});

export default hoopstirTheme


// MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-formControl MuiInput-formControl MuiInputBase-adornedEnd

// MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-formControl MuiInput-formControl


// MuiFormControl-root MuiTextField-root
// MuiFormControl-root MuiTextField-root DOB